export const initialValues = {
	email: "",
	password: "",
	confirmPassword: "",
	name: "",
	surname: "",
};
